import {
  PlatformModule,
} from '@angular/cdk/platform';
import {
  NgModule,
} from '@angular/core';
import {
  RulesEngineRunnerModule,
} from '@o3r/rules-engine';
import {
  DeviceDetectionFactsService,
} from './device-detection.facts.service';

@NgModule({
  imports: [
    RulesEngineRunnerModule,
    PlatformModule
  ],
  providers: [
    DeviceDetectionFactsService
  ]
})
export class DeviceDetectionFactsModule {}
